import React from 'react';
import ParentDocCard from '../../common/ParentDocCard';
import { CustomComponentTable } from './CustomComponentTable';

export const CustomComponentTab = ({
  projectId,
  version,
  customComponents,
  actions,
  flag,
  isReadOnly,
}) => {
  return (
    <>
      <CustomComponentTable
        projectId={projectId}
        version={version}
        customComponents={customComponents}
        actions={actions}
        flag={flag}
        isReadOnly={isReadOnly}
      />
      <ParentDocCard>
        <h5>
          <b>About Custom Component</b>
        </h5>
        <p>Custom Component</p>
        <br />
      </ParentDocCard>
    </>
  );
};
